import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';

export const QrcodeScanScreen = wrapNavigatorScreen(() => null);
